<template>
  <div class="page landing">
    <div class="banner">
      <div class="download-btn" @click="download"></div>
    </div>
    <!-- 特色 -->
    <div class="property">
      <div class="property-item">
        <div class="item-icon">
          <img src="https://static.ndmicro.com/tmd/landing/equity/images/icon01@2x.png" alt="">
        </div>
        <div class="item-content">
          <p class="p1">快速审批</p>
          <p class="p2">最快5分钟放款</p>
        </div>
      </div>
      <div class="property-item">
        <div class="item-icon">
          <img src="https://static.ndmicro.com/tmd/landing/equity/images/icon_02@2x.png" alt="">
        </div>
        <div class="item-content">
          <p class="p1">分期偿还</p>
          <p class="p2">可分12期偿还</p>
        </div>
      </div>
      <div class="property-item">
        <div class="item-icon">
          <img src="https://static.ndmicro.com/tmd/landing/equity/images/icon_03@2x.png" alt="">
        </div>
        <div class="item-content">
          <p class="p1">放心使用</p>
          <p class="p2">正规持牌机构</p>
        </div>
      </div>
    </div>
    <!-- 公司信息 -->
    <section class="company">
      <div class="company-item">
        <p>贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准(综合年化利率区间15.4%-24%，单利计算)</p>
        <p>贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
      </div>
      <div class="company-item">
        <p>重庆市崇天小额贷款有限公司</p>
        <p>公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
        <p>渝公网安备 50010802002638号I渝ICP备18009772号-1</p>
      </div>
    </section>
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
export default {
  name: 'landingEquity',
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    callAppBySchema (schema) {
      return new Promise((resolve, reject) => {
        let node = document.createElement('iframe')
        const body = document.body
        node.style.display = 'none'

        let clear = function (evt, isTimeout) {
          node.onload = null
          body.removeChild(node)
          node = null
        }

        node.onload = clear
        node.src = schema
        body.appendChild(node)
        let now = Date.now()

        setTimeout(() => {
          let newTime = Date.now()

          if (newTime - now > 1100) {
            resolve(true)
          } else {
            resolve(false)
          }
          clear()
        }, 1000)
      })
    },
    download () {
      this.downloadApp()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page.landing{
  .banner{
    width: 750px;
    height: 1130px;
    margin: 0 auto;
    background: url('https://static.ndmicro.com/tmd/landing/equity/images/img_01@2x.png') center no-repeat;
    background-size: cover;
    position: relative;
    .download-btn{
      width: 560px;
      height: 154px;
      background: url(https://static.ndmicro.com/tmd/landing/equity/images/btn_jiekuan@2x.png) center no-repeat;
      background-size: cover;
      position: absolute;
      bottom: 52px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
    }
  }
  .property {
    display: flex;
    margin: 0 auto;
    padding-bottom: 75px;
    background-color: #292742;
    padding-top: 20px;
    .property-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .item-icon {
        width: 60px;
        height: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item-content {
        .p1 {
          margin-top:18px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #F3D5BD;
          line-height: 40px;
        }
        .p2 {
          height: 30px;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 30px;
        }
      }
    }
  }
  .company {
    width: 750px;
    height: 240px;
    font-size: 20px;
    line-height: 28px;
    background-color: #444264;
    color: #FFFFFF;
    padding: 24px 30px;
    .company-item{
      & + .company-item{
        margin-top: 24px;
      }
    }
  }
}
</style>